export default "__VITE_ASSET__DlxJLl9P__"